var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"fill-current text-white",attrs:{"src":"https://connect-cdn.intellectualpoint.com/assets/images/logos/IntellectualPoint.png","alt":"Logo","width":"140","draggable":"false"}})
}
var staticRenderFns = []

export { render, staticRenderFns }